<template>
    <div>
        <div class="_flex">
            <el-input placeholder="商品名称" v-model="search.good_name" size="small" style="width: 150px;margin-right:10px;"/>
            <el-input placeholder="商品别名" v-model="search.good_alias" size="small" style="width: 150px;margin-right:10px;"/>
            <el-select v-model="search.good_source" clearable size="small" placeholder="来源" style="margin-left: 10px;">
                <el-option label="平台自营商品" value="1"></el-option>
                <el-option label="供应链商品" value="3"></el-option>
                <el-option label="供应商商品" value="4"></el-option>
            </el-select>
            <el-select v-model="search.good_type" clearable size="small" placeholder="类型" style="margin-left: 10px;" :disabled="good_type > 0">
                <el-option label="标准商品" :value="1"></el-option>
                <el-option label="虚拟商品" :value="2"></el-option>
                <el-option label="技能服务" :value="3"></el-option>
                <el-option label="定制商品" :value="4"></el-option>
                <el-option label="礼品" :value="5"></el-option>
                <el-option label="赠品" :value="6"></el-option>
            </el-select>
            <el-cascader v-model="search.cate_id" clearable :options="goodCateList" :props="{value:'cate_id',label:'cate_name',checkStrictly:true}" size="small" @visible-change="getGoodsCateList" placeholder="商品分类" style="margin-left: 10px;"></el-cascader>
            <el-button size="small" style="margin-left: 10px;" @click="getGoodLists(1)">筛选</el-button>
            <el-button size="small" type="danger" @click="clearSelection">清空选择({{selectedGoods.length}})</el-button>
        </div>
        <div style="margin-top: 10px;">
            <el-table :data="goodArr" stripe :header-cell-style="{ background:'#f5f5f5'}" row-key="sku_id"
            @selection-change="handleSelectionChange"
            ref="multipleTable"
            style="width: 100%"
            max-height="500px"
            @select="handleSelect"
            @select-all="handleSelectAll"
            :default-checked-key="value.map(admin => admin.id)"
            >
                <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
                <el-table-column label="商品id" prop="good_id" width="80"/>
				<el-table-column label="来源" prop="good_source_text" width="100"/>
                <el-table-column label="类型" prop="good_type_text" width="100"/>
				<el-table-column label="商品名称" prop="good_name" width="300">
                    <template v-slot="{row}">
                        <el-tooltip :content="row.good_name" placement="top-start">
                            <span style="max-width:200px;display: inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{row.good_name}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="商品别名" prop="good_alias" width="200">
                    <template v-slot="{row}">
                        <el-tooltip :content="row.good_alias" placement="top-start">
                            <span style="max-width:200px;display: inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{row.good_alias}}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="state_text" width="100"/>
				<el-table-column label="规格id" prop="sku_id" width="100"/>
				<el-table-column label="规格名称" prop="spec_data_str" width="300"/>
				<el-table-column label="库存" prop="stock"  width="100"/>
				<el-table-column label="成本价" prop="cost_price"  width="100" v-if="show_cost" />
				<el-table-column label="销售价" prop="sale_price"  width="100"/>
            </el-table>
            
            <el-pagination background style="margin-top: 10px;"
                @size-change="changeLimit"
                :current-page="search.page"
                @current-change="changePage"
                :page-size="search.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="search.total">
            </el-pagination>
        </div>
        <div class="t_c mt_40">
            <el-button @click="close">取 消</el-button>
            <el-button type="success" @click="submit">确 定</el-button>
        </div>
    </div>
</template>

<script>
import { goodLists,goodsCateLists } from "@/request/apis.js"

export default {
    name: 'GoodSelect',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        good_type: {
            type: Number,
            default: 0
        },
        show_cost: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            search: {
                good_name: '',
                page: 1,
                limit: 10,
                total: 0,
                good_type: '',
                good_source: '',
                cate_id: [],
            },
            goodArr: [],
            selectedGoods: [],
            goodCateList: [],
            toggleFinish: false,
        }
    },
    mounted() {
        console.log('goodselect mounted')
        this.search.good_type = this.good_type ? this.good_type : this.search.good_type;
        this.getGoodLists();
        this.selectedGoods = [...this.value];
    },
    methods: {
        async getGoodLists(page = 0){
            if(page){
                this.search.page = page;
            }
            let cateIdArr = this.search.cate_id.filter(item => item);
            let cate_id = cateIdArr[cateIdArr.length - 1];
            var res = await goodLists({...this.search, cate_id, state: 1});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.search.total = res.count;
            this.goodArr = [];
            res.data.forEach(i => {
                i.skus.forEach(j => {
                    j.good_id = i.good_id
                    j.good_source_text = i.good_source_text
                    j.good_type_text = i.good_type_text
                    j.good_name = i.good_name
                    j.good_alias = i.good_alias
                    j.good_type = i.good_type
                    j.warehouse_id = i.warehouse_id
                })
                this.goodArr.push(...i.skus)
            });
            this.$nextTick(() => {
                this.toggleFinish = false;
                this.goodArr.forEach(row => {
                    if (this.selectedGoods.some(selected => selected.sku_id === row.sku_id)) {
                        console.log('inittableSelect', this.selectedGoods)
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    }
                });
                this.toggleFinish = true;
            });
        },
        changeLimit(limit){
            this.search.limit = limit;
            this.getGoodLists();
        },
        changePage(page){
            this.getGoodLists(page);
        },
        getGoodsCateList(query) {
            if(!query){
                return;
            }
            goodsCateLists({ cate_type: '1' }).then(res => {
                if (res.code == 0) {
                    this.goodCateList = res.data;
                }else{
                    return this.$message.error(res.msg);
                }
            }).catch(err => {})
        },
        handleSelectionChange(selection) {
            if(!this.toggleFinish){
                return;
            }

            console.log('handleSelectionChange', selection)
            let currentIdArr = this.goodArr.map(item => item.sku_id);
            let selectionIdArr = selection.map(item => item.sku_id);
            let removeIdArr = currentIdArr.filter(id => !selectionIdArr.includes(id));
            this.selectedGoods = this.selectedGoods.filter(item => !removeIdArr.includes(item.sku_id));
            let selectedIdArr = this.selectedGoods.map(item => item.sku_id);
            selection.forEach(ele => {
                if(!selectedIdArr.includes(ele.sku_id)){
                    this.selectedGoods.push(ele);
                }
            });
            console.log('handleSelectionChange', this.selectedGoods)

            // this.selectedGoods = selection;
            // this.$emit('input', this.selectedGoods); // 传递选中的值回父组件
        },
        handleSelect(selection, row) {
            // 处理单选事件，如果需要的话
        },
        handleSelectAll(selection) {
            // 处理全选事件，如果需要的话
        },
        close(){
            this.$emit('close');
        },
        submit(){
            this.$emit('input', this.selectedGoods);
            this.$emit('close');
        },
        clearSelection() {
            this.$refs.multipleTable.clearSelection();
            this.selectedGoods = [];
            // this.$emit('input', this.selectedGoods);
        }
    }
}
</script>

<style scoped>
</style>